import React from "react";
import { Collapse, Spin } from "antd";
import styled from "styled-components";
import { theme } from "../../../theme";
import { ReactComponent as Minus } from "../../../assets/icons/Minus.svg";
import { ReactComponent as ListPlus } from "../../../assets/icons/ListPlus.svg";
import PaginationComponent from "../../molecures/Pagination";
import { numberWithCommas } from "../../../shared/utils";
import EmptyBoxComp from "../../molecures/EmptyBoxComp";

const { Panel } = Collapse;

export interface CollapseProps {
  data: undefined | { [index: string]: any }[];
  title: string;
  qustionPrefixKey?: string;
  qustionCategoryKey?: string;
  questionTitleKey?: string;
  answerPrefixKey?: string;
  isLoading?: boolean;
  answerKey?: string;
  totalCount?: number;
  currentPage?: number;
  currentPageSize?: number;
  onPageChagned: (e: number) => void;
}

const CustomCollapse: React.FC<CollapseProps> = ({
  data,
  isLoading,
  qustionPrefixKey,
  answerKey,
  answerPrefixKey,
  qustionCategoryKey,
  questionTitleKey,
  currentPage,
  currentPageSize,
  onPageChagned,
  totalCount,
}) => {
  return (
    <CollapseContainer>
      {isLoading ? (
        <Spin spinning={isLoading}>
          <StyledCollapse
            style={{
              backgroundColor: "white",
              border: "0px solid transparent",
              boxShadow: "none",
              margin: "0px",
              padding: "0px",
            }}
            expandIconPosition="right"
            expandIcon={({ isActive }) =>
              isActive ? (
                <ListPlus
                  stroke={theme.colors.gray1}
                  fill={theme.colors.gray1}
                />
              ) : (
                <Minus stroke={theme.colors.gray1} fill={theme.colors.gray1} />
              )
            }
          />
        </Spin>
      ) : data ? (
        data?.length > 0 ? (
          <StyledCollapse
            style={{
              backgroundColor: "white",
              border: "0px solid transparent",
              boxShadow: "none",
              margin: "0px",
              padding: "0px",
              borderTop: `1px solid ${theme.colors.gray7}`,
            }}
            accordion
            expandIconPosition="right"
            expandIcon={({ isActive }) => (isActive ? <Minus /> : <ListPlus />)}
          >
            {data?.map((val, index) => {
              return (
                <StyledPanel
                  key={index.toString()}
                  header={
                    <CustomHeaders onClick={() => {}}>
                      <CustomHeaderPrefix>
                        {qustionPrefixKey || "Q"}
                      </CustomHeaderPrefix>
                      <CustomCategoryWrapper>
                        {val[qustionCategoryKey || "group"]}
                      </CustomCategoryWrapper>
                      <CustomTitleWrapper>
                        {val[questionTitleKey || "question"]}
                      </CustomTitleWrapper>
                    </CustomHeaders>
                  }
                  style={{}}
                >
                  <CustomAnswerWrapper
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <CustomAnswerPrefix>
                      {answerPrefixKey || "A"}
                    </CustomAnswerPrefix>
                    <CustomAnswerBodyWrapper>
                      {val[answerKey || "answer"]}
                    </CustomAnswerBodyWrapper>
                  </CustomAnswerWrapper>
                </StyledPanel>
              );
            })}
          </StyledCollapse>
        ) : (
          <EmptyBoxComp />
        )
      ) : (
        <EmptyBoxComp />
      )}
      {data && data?.length > 0 && (
        <PaginationWrapper>
          <span>
            총 <TotalCount>{numberWithCommas(totalCount || 0)}</TotalCount>
          </span>
          <PaginationComponent
            pageSize={currentPageSize || 10}
            currentPage={currentPage || 1}
            totalCount={totalCount || 0}
            setCurrentPage={onPageChagned}
          />
        </PaginationWrapper>
      )}
    </CollapseContainer>
  );
};
export default CustomCollapse;
const CollapseContainer = styled.div`
  padding: 24px;
`;
const StyledPanel = styled(Panel)`
  &&:hover {
    background-color: ${theme.colors.gray9};
  }
`;
const StyledCollapse = styled(Collapse)`
  .ant-collapse-header {
    width: 100%;
  }
  div.ant-collapse-item-active .ant-collapse-header div {
    color: ${theme.colors.mainPrimary3};
  }
  div.ant-collapse-item-active .ant-collapse-header span {
    color: ${theme.colors.mainPrimary3};
  }
`;
const CustomAnswerWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  padding: 32px 0px;
  background-color: #f3f5fa;
  word-break: break-all;
  white-space: pre-wrap;
`;
const CustomAnswerPrefix = styled.div`
  min-width: 59px;

  display: flex;
  align-items: flex-start;
  justify-content: center;
  ${theme.typo.heading.b14};
`;
const CustomAnswerBodyWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 0px 16px 0px 16px;
  white-space: pre-wrap;
  justify-content: flex-start;
  ${theme.typo.body.r16};
  flex-grow: 1;
  font-weight: 400;
  word-break: break-all;
  width: 100px;
  color: ${theme.colors.gray3};
`;
const CustomHeaders = styled.div`
  height: 56px;

  display: flex;

  ${theme.typo.heading.b14};
`;
const CustomHeaderPrefix = styled.div`
  width: 59px;
  height: 56px;
  line-height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.gray1};
`;
const CustomCategoryWrapper = styled.div`
  width: 160px;
  display: flex;
  padding: 16px;
  align-items: center;

  justify-content: flex-start;
  height: 56px;
`;
const CustomTitleWrapper = styled.div`
  flex: 1 1 0%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 16px;
  white-space: pre-wrap;
`;

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 64px;
  padding: 0px 24px;
  background-color: white;
`;
const TotalCount = styled.span`
  color: ${theme.colors.gray1};

  ${theme.typo.heading.b14};
  line-height: 24px;
  height: 24px;
`;
